<expo-nav></expo-nav>
<div class="expo-main-container">
    <router-outlet></router-outlet>
    <expo-bag></expo-bag>
</div>
<expo-footer></expo-footer>